import { TipoTipologica } from "../tipologiche/tipo-tipologica";

export class SpeseDiGiudizio {
    id: string;
    descrizioneSpesa: TipoTipologica;
    valoreSpesa: number;
}